import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'

export const TRANSFORMER = graphql.transformers.IN.if<
  ents.extra.common.FaFunction.Categorization.Identifiable | Nullish,
  ents.extra.common.FaFunction.Categorization.Ids,
  graphql.schema.FaFunctionCategorizationInput | undefined
>(
  ents.extra.common.FaFunction.Categorization.Ids.isIds,
  graphql.transformers.IN.object<
    ents.extra.common.FaFunction.Categorization.Ids,
    graphql.schema.FaFunctionCategorizationInput
  >({
    categoryId: graphql.transformers.IN.validate(
      transformers.PASS_THROUGH,
      TypeAsserter.assertIsNotNullish,
    ),
    subcategoryId: transformers.PASS_THROUGH,
  }),
  graphql.transformers.IN.object<
    ents.extra.common.FaFunction.Categorization,
    graphql.schema.FaFunctionCategorizationInput
  >({
    categoryId: categorization => categorization.category.id,
    subcategoryId: categorization => categorization.subcategory?.id,
  }),
)
